import { NextPage }             from 'next';
import AppHead                  from '@core/components/common/AppHead';
import AppLayout                from '@layouts/AppLayout';
import useIsMounted             from '@hooks/use-is-mounted';
import { ClientOnly }           from '@lib/ClientOnly';
import { FavoritesPageLanding } from '@features/favorites/containers/FavoritesPageLanding';


const FavoritesPage: NextPage = () => {

    const isMounted = useIsMounted();

    return isMounted && (

        <ClientOnly>
            <FavoritesPageLanding/>
        </ClientOnly>

    );
};

// @ts-expect-error
FavoritesPage.getLayout = function getLayout(page: typeof FavoritesPage) {

    return (
        <>
            <AppHead
                title="Your Favorite Properties"
                description="Properties you are interested in and have added to your list of favourites in order to book or have a look at later."/>

            <AppLayout
                requireAuth={true}
                noHeader={false}
            >
                {/*// @ts-expect-error*/}
                {page}
            </AppLayout>
        </>
    );
};

export default FavoritesPage;
